/* ─────────────────────────────────────────────────────────────
   ask-trigger — decoupled "open the Ask widget" signal.

   The Ask widget owns its open state locally, so contextual entry
   points (e.g. a "Need help?" link on a feature page) open it by
   dispatching a window CustomEvent rather than reaching into its
   state. The widget listens for ASK_OPEN_EVENT and, when present,
   prefills the composer with `prefill`.
   ───────────────────────────────────────────────────────────── */

export const ASK_OPEN_EVENT = 'ask:open'

export interface AskOpenDetail {
  /** Optional text to prefill the composer with (a suggested question). */
  prefill?: string
}

/** Open the global Ask widget, optionally prefilling a suggested question. */
export function openAskAgent(prefill?: string): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<AskOpenDetail>(ASK_OPEN_EVENT, { detail: { prefill } }))
}
